class AnnouncementTicker extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.viewport = this.querySelector('[data-announcement-ticker-viewport]');
    this.item = this.querySelector('[data-announcement-ticker-item]');

    if (!this.viewport || !this.item) return;

    const configuredSpeed = Number.parseFloat(this.dataset.tickerSpeed);
    this.speed = Number.isFinite(configuredSpeed) && configuredSpeed > 0 ? configuredSpeed : 48;
    this.scheduleUpdate = this.scheduleUpdate.bind(this);

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.item);
    } else {
      window.addEventListener('resize', this.scheduleUpdate, { passive: true });
    }

    document.fonts?.ready.then(this.scheduleUpdate);
    this.scheduleUpdate();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.scheduleUpdate);
    cancelAnimationFrame(this.updateFrame);
  }

  scheduleUpdate() {
    cancelAnimationFrame(this.updateFrame);
    this.updateFrame = requestAnimationFrame(() => this.update());
  }

  update() {
    const viewportWidth = this.viewport.clientWidth;
    const itemWidth = this.item.scrollWidth;
    const shouldScroll = viewportWidth > 0 && itemWidth > viewportWidth - 24;

    this.classList.toggle('is-overflowing', shouldScroll);
    if (!shouldScroll) {
      this.style.removeProperty('--announcement-ticker-start');
      this.style.removeProperty('--announcement-ticker-end');
      this.style.removeProperty('--announcement-ticker-duration');
      return;
    }

    const travelDistance = viewportWidth + itemWidth;
    this.style.setProperty('--announcement-ticker-start', `${viewportWidth}px`);
    this.style.setProperty('--announcement-ticker-end', `${-itemWidth}px`);
    this.style.setProperty('--announcement-ticker-duration', `${Math.max(14, travelDistance / this.speed)}s`);
  }
}

if (!customElements.get('announcement-ticker')) {
  customElements.define('announcement-ticker', AnnouncementTicker);
}
